// src/components/templates/TagPageTemplate/TagPageTemplate.jsx
import React from 'react';
import PropTypes from 'prop-types';
import ArticlePageTemplate from '../ArticlePageTemplate/ArticlePageTemplate';

/**
 * TagPageTemplate - Template para páginas de artigos filtrados por tag
 *
 * Este componente estende o ArticlePageTemplate com configurações específicas
 * para páginas de tag. Segue o princípio do Atomic Design como um "template".
 */
const TagPageTemplate = ({
  tagName,
  onRemoveFromTag,
  ...rest
}) => {
  return (
    <ArticlePageTemplate
      {...rest}
    />
  );
};

TagPageTemplate.propTypes = {
  tagName: PropTypes.string,
  onRemoveFromTag: PropTypes.func,

  // Todas as props do ArticlePageTemplate
  title: PropTypes.string.isRequired,
  searchValue: PropTypes.string.isRequired,
  onSearch: PropTypes.func.isRequired,
  selectionMode: PropTypes.bool.isRequired,
  onToggleSelectionMode: PropTypes.func.isRequired,
  filtersOpen: PropTypes.bool.isRequired,
  onToggleFilters: PropTypes.func.isRequired,
  sortBy: PropTypes.string.isRequired,
  onSortChange: PropTypes.func.isRequired,
  sortOptions: PropTypes.array,
  cardsPerPage: PropTypes.number.isRequired,
  onCardsPerPageChange: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['compact', 'detailed', 'list']).isRequired,
  onVariantChange: PropTypes.func.isRequired,
  onNewArticle: PropTypes.func,

  // Estatísticas para MainToolbar
  totalItems: PropTypes.number,
  filteredItems: PropTypes.number,
  selectedItems: PropTypes.number,

  // Props para filtro de período
  timePeriod: PropTypes.string,
  onTimePeriodChange: PropTypes.func,
  totalCount: PropTypes.number,

  // AdvancedFilters props
  dateValue: PropTypes.string,
  onDateChange: PropTypes.func.isRequired,
  dateOptions: PropTypes.array,
  selectedSources: PropTypes.array,
  onSourcesChange: PropTypes.func.isRequired,
  sourceOptions: PropTypes.array.isRequired,
  selectedSentiments: PropTypes.array,
  onSentimentsChange: PropTypes.func.isRequired,
  sentimentOptions: PropTypes.array,
  selectedTags: PropTypes.array,
  onTagsChange: PropTypes.func.isRequired,
  tagOptions: PropTypes.array.isRequired,
  selectedCollections: PropTypes.array,
  onCollectionsChange: PropTypes.func.isRequired,
  collectionOptions: PropTypes.array.isRequired,
  selectedMediaTypes: PropTypes.array,
  onMediaTypesChange: PropTypes.func.isRequired,
  mediaTypeOptions: PropTypes.array.isRequired,
  selectedTiers: PropTypes.array,
  onTiersChange: PropTypes.func.isRequired,
  tierOptions: PropTypes.array.isRequired,
  selectedStatuses: PropTypes.array,
  onStatusesChange: PropTypes.func,
  showTagFilter: PropTypes.bool,
  showCollectionFilter: PropTypes.bool,
  onClearFilters: PropTypes.func,

  // ActiveFiltersIndicator props
  activeFilters: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ),
  onRemoveFilter: PropTypes.func,
  activeFiltersExpanded: PropTypes.bool,
  onToggleActiveFiltersExpanded: PropTypes.func,

  // SelectionToolbar props
  onSelectAll: PropTypes.func.isRequired,
  onFavorite: PropTypes.func.isRequired,
  onAddTag: PropTypes.func.isRequired,
  onAddToCollection: PropTypes.func.isRequired,
  onSetSentiment: PropTypes.func.isRequired,
  onSetRead: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onClearSelection: PropTypes.func.isRequired,
  selectedCount: PropTypes.number,
  allSelected: PropTypes.bool,
  showRemoveFromTag: PropTypes.bool,
  showRemoveFromCollection: PropTypes.bool,
  onRemoveFromCollection: PropTypes.func,

  // Conteúdo principal
  loading: PropTypes.bool,
  error: PropTypes.string,
  children: PropTypes.node,

  // Snackbar
  snackbar: PropTypes.shape({
    open: PropTypes.bool,
    message: PropTypes.string,
    severity: PropTypes.oneOf(['success', 'info', 'warning', 'error'])
  }),
  onCloseSnackbar: PropTypes.func.isRequired,

  className: PropTypes.string
};

export default TagPageTemplate;
